<script>
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import SelectWithSearch from "../../Common/SelectWithSearch.vue";
import { WarehousePath, LocationPath,GravyPath,PackagingPath,InboundOrderPath } from "../../../../../path";
import Swal from 'sweetalert2';
import axios from "axios";
    export default {
        components : {
    Layout,
    PageHeader,
    SelectWithSearch
},
        computed : {
            WarehousePath(){
                return WarehousePath;
            },
            LocationPath(){
                return LocationPath;
            },
            GravyPath(){
                return GravyPath;
            },
            PackagingPath(){
                return PackagingPath;
            },
            InboundOrderPath(){
                return InboundOrderPath;
            }
        },
        data(){
            return {
                type_options : [
                    {
                        key : 'gravies', value : 'Gravies'
                    },
                    {
                        key : 'packagings', value : 'Packaging'
                    }
                ],
                title: "Packaging Transfer Request",
                items: [
                    {
                        text: "List",   
                    },
                    {
                        text: "Request",
                        active: true,
                    },
                ],
                key : 1,
                key2 : 4,
                key3 : 5,                
                form : {},
                type : 'packaging',
                items_data : [],
                base_url : process.env.VUE_APP_API_BACKEND_URL
            }
        },
        methods :{
            setToWarehouse(v){
                this.form.warehouse_id = v;
                this.key2+=1;
            },
            addItem(){
                this.items_data.push({
                    id : 'k'+(parseInt(this.items_data.length) + 1),
                    item_id : null,
                    type : 'packaging'
                })
            },
            removeItem(i){
                this.items_data.splice(i,1);
            },
            selectedType(v,ii){
                this.items_data[ii].type = v;                
                this.items_data[ii].id = 'kt'+(ii+1+v); 
                console.log(v);                                
            },
            async processBarcode() {      
                if(this.barcode.includes('PP')){
                    await this.getBarcocePackagings();
                }                              
                this.batch_code = '';
                this.$refs.barcodeInput.value = '';
            },
            async getBarcocePackagings(){
                try {
                    let res = await axios.get(this.base_url + PackagingPath.FETCH_PACKAGING_WITH_BATCH,{
                    params : {
                        batch_code : this.barcode,
                        warehouse_id : this.form?.from_warehouse_id,
                        location_id : this.form?.from_location_id
                    }
                    });
                    if(res.data.status){
                        let d = {};
                        d.batch_code = this.barcode;
                        d.packaging_id = res.data.data.packaging.id;
                        d.packaging_name = res.data.data.packaging.name;
                        d.has_stock = (res.data.data.qty_final - res.data.data.qty_consumed)
                        let check = this.items_data.findIndex(f => f.batch_code == d.batch_code);
                        if(check !== -1){
                            this.items_data[check].qty += 1;            
                        }else{            
                            d.qty = 1;                            
                            // d.batch_id.push(this.barcode);
                            this.items_data.push(d);
                        }         
                    }
                }catch (e){
                    console.log(e);
                }
            },
            selectedItem(ii,v){                
                this.items_data[ii].item_id = v;    
                this.addItem();            
            },
            async saveTransfer(){
                try {
                    this.form.items = this.items_data;                    
                    this.form.order_type = 'transfer';
                    let res = await axios.post(this.base_url + InboundOrderPath.SAVE_TRANSFER_BATCH,this.form);
                    if(res.data.status){
                        Swal.fire("Saved Successfully");
                        this.$router.push({path : '/packaging_transfer_batches'});
                    }
                } catch (error) {
                    console.log(error);
                    Swal.fire("Failed to save");
                }
            }
        }
    }
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-card>
            <b-card-header>Transfer Batch</b-card-header>
            <b-card-body>
                <b-row>
                    <b-col sm="6">
                        <label>From Warehouse</label>
                        <SelectWithSearch :selected_data="[form.from_warehouse_id]" selected_by="id" :search_api="WarehousePath.WAREHOUSE_SEARCH" track_by="id" display="name" @selectedOption="((v) => {form.from_warehouse_id = v; key++;})"></SelectWithSearch>
                    </b-col>
                    <b-col sm="6" :key="key">
                        <label>From Location</label>
                        <SelectWithSearch v-if="form.from_warehouse_id" :selected_data="[form.from_location_id]" selected_by="id" :search_api="LocationPath.LOCATION_SEARCH" track_by="id" display="location" @selectedOption="((v) => form.from_location_id = v)" :extra_params="'&warehouse_id='+form.from_warehouse_id"></SelectWithSearch>
                    </b-col>                                
                    <b-col sm="6">
                        <label>To Warehouse</label>
                        <SelectWithSearch :selected_data="[form.warehouse_id]" selected_by="id" :search_api="WarehousePath.WAREHOUSE_SEARCH" track_by="id" display="name" @selectedOption="setToWarehouse"></SelectWithSearch>
                    </b-col>
                    <b-col sm="6" :key="key2">
                        <label>To Location</label>
                        <SelectWithSearch v-if="form.warehouse_id" :selected_data="[form.location_id]" selected_by="id" :search_api="LocationPath.LOCATION_SEARCH" track_by="id" display="location" @selectedOption="((v) => form.location_id = v)" :extra_params="'&warehouse_id='+form.warehouse_id"></SelectWithSearch>
                    </b-col>                        
                    <b-col sm="4">
                        <label>Transfer On</label>
                        <b-datepicker v-model="form.transfer_on"></b-datepicker>
                    </b-col>                            
                </b-row>
                <b-button variant="primary" class="mt-4" @click="addItem"><i class="fa fa-plus"></i> Add Line Item</b-button>
                <input
                    type="text"
                    v-model="barcode"
                    @keyup.enter="processBarcode"
                    ref="barcodeInput"
                    placeholder="Scan a barcode"
                    class="form-control mb-4"
                />
                <table class="table">
                    <thead>
                        <tr>              
                            <th>Batch</th>              
                            <th>Packaging</th>
                            <th>Qty To Transfer</th>                            
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(i,ii) in items_data" :key="i.id">                            
                            <!-- <td>
                                {{ i.batch_code }}
                            </td>
                            <td>
                                {{ i.packaging_name }}
                            </td> -->
                            <td>                                
                                Packaging
                            </td>
                            <td>                                                
                                <SelectWithSearch :search_api="PackagingPath.SEARCH_PACKAGING" :selected_data="[i.item_id]" selected_by="id" track_by="id" display="name" @selectedOption="selectedItem(ii,$event)"></SelectWithSearch>
                            </td>
                            <td>
                                <b-input type="number" v-model="i.qty"></b-input>
                            </td>
                            <td>
                                <b-button variant="danger" @click="removeItem(ii)" size="sm"><i class="fa fa-trash"></i></b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <b-button @click="saveTransfer" variant="success">Save Transfer</b-button>
            </b-card-body>
        </b-card>
    </Layout>
</template>

<style>
    
</style>